(function() {
  // Constants
  const currentScript = document.currentScript;
  const variantsMetafieldsOrdered = JSON.parse(currentScript.dataset.variantsMetafieldsOrdered);

  // Helpers
  function handleAddToCartButtonDisplay() {
    const isProductPage = window.location.href.includes('/products/');
    if (!isProductPage) return;

    const button = document.querySelector('button[name="add"][data-add-to-cart]')
    if (!button) return;

    const buttonText = document.querySelector('button[name="add"][data-add-to-cart] [data-add-to-cart-text]')
    if (!buttonText) return;

    const currentVariant = document.querySelector('input[name="id"]')
    const variantId = currentVariant.value;
    if (!variantId) return;

    const productElemJSON = document.querySelector('[data-product-json]')
    if (!productElemJSON) return;

    const productJSONText = productElemJSON.innerHTML;
    if (!productJSONText) return;

    const productJSON = JSON.parse(productJSONText);
    if (!productJSON) return;

    const productDataWithMetafields = {
      ...productJSON,
      variants: productJSON.variants.map((variant, index) => ({
        ...variant,
        metafields: variantsMetafieldsOrdered[index]
      }))
    }

    let isSoldOut = false;
    let isComingSoon = false;

    if (productDataWithMetafields?.variants.length) {
      const targetVariant = productDataWithMetafields.variants.find((x) => `${x.id}` === `${variantId}`)
      if (targetVariant) {
        isSoldOut = (targetVariant.available === false);
  
        if (targetVariant?.metafields.length) {
          const comingSoonMetafield = targetVariant.metafields.find((x) => x.key === 'coming_soon')
          if (comingSoonMetafield) {
            isComingSoon = isSoldOut && JSON.parse(`${comingSoonMetafield.value}`.toLowerCase()) === true
          }
        }
      }
    }

    if (isComingSoon) {
      button.classList.add('button--disabled')
      button.setAttribute('disabled', '');
      buttonText.innerHTML = 'Coming Soon'
    } else if (isSoldOut) {
      button.classList.add('button--disabled')
      button.setAttribute('disabled', '');
      buttonText.innerHTML = 'Sold Out'
    } else {
      button.classList.remove('button--disabled')
      button.removeAttribute('disabled');
    }
  }

  // Event Listeners
  document.addEventListener('DOMContentLoaded', function() {
    handleAddToCartButtonDisplay();
  })

  document.addEventListener('theme:variant:change', function() {
    handleAddToCartButtonDisplay()
  });
})();
